import Axios from 'axios';
import { API, CONFIG } from '../utils/constant';

// Form Submission
function propertyFormSubmit() {
    const contactForm = document.querySelector('#contact-form')
    const modalContactForm = document.querySelector('#modal-contact-form')
    if (contactForm == null || undefined) return

    // Form variable
    let region
    let project
    let salutation
    let firstname
    let lastname
    let email
    let phone
    let pdpa
    let isValid = false

    // Modal Form variable
    let modalRegion
    let modalProject
    let modalSalutation
    let modalFirstname
    let modalLastname
    let modalEmail
    let modalPhone
    let modalPdpa
    let modalIsValid = false
    
    contactForm.addEventListener('submit', function(event){
        checkvalidation()
        event.preventDefault()

        if (isValid) {
            const payload = {
                full_name: `${salutation} ${firstname} ${lastname}`,
                email: email,
                phone_number: phone,
                bu_name: "EcoWorld Singapore",
                source: "Corporate Website",
                remarks_1: `Project Region: ${region} \n Project: ${project}`
            }

            Axios.post(
                API,
                payload,
                CONFIG
            ).then( res => {
                console.log(res.data);
                console.log(new Date().toLocaleTimeString());
                alert('Thank you for your registration. Our sales consultants will be in touch with you.')
            }).catch( err => {
                console.log(err);
                if (err.response) {
                    console.log(err.response);
                }
            })
        }
    })
    
    modalContactForm.addEventListener('submit', function(event){
        checkModalValidation()
        event.preventDefault()

        if (modalIsValid) {
            const payload = {
                full_name: `${modalSalutation} ${modalFirstname} ${modalLastname}`,
                email: modalEmail,
                phone_number: modalPhone,
                bu_name: "EcoWorld Singapore",
                source: "Corporate Website",
                remarks_1: `Project Region: ${region} \n Project: ${project}`
            }

            Axios.post(
                API,
                payload,
                CONFIG
            ).then( res => {
                console.log(res.data);
                console.log(new Date().toLocaleTimeString());
                alert('Thank you for your registration')
            }).catch( err => {
                console.log(err);
                if (err.response) {
                    console.log(err.response);
                }
            })
        }
    })
    
    function checkvalidation(){
        region = contactForm.querySelector('#form-project-region').value
        project = contactForm.querySelector('#form-project-name').value
        salutation = contactForm.querySelector('#form-salutation').value
        firstname = contactForm.querySelector('#form-first-name').value
        lastname = contactForm.querySelector('#form-last-name').value
        email = contactForm.querySelector('#form-email').value.toLowerCase()
        phone = contactForm.querySelector('#form-phone').value
        pdpa = contactForm.querySelector('#form-pdpa').checked
    
        if(region == ""){
            alert('Please select a project region.')
            isValid = false
        }
        else if(project == ""){
            alert('Please select a project.')
            isValid = false
        }
        else if(salutation == ""){
            alert('Please select your salutation.')
            isValid = false
        }
        else if (firstname == ""){
            alert('Please fill up your first name.')
            isValid = false
        }
        else if (lastname == ""){
            alert('Please fill up your last name.')
            isValid = false
        }
        else if (!validateEmail(email)){
            alert('Please fill up your email.')
            isValid = false
        }
        else if (phone == ""){
            alert('Please fill up your contact number.')
            isValid = false
        }
        else if (!pdpa){
            alert('Please read and agree the Terms & Conditions.')
            isValid = false
        } else {
            isValid = true
        }
    
    }
    
    function checkModalValidation(){
        modalRegion = modalContactForm.querySelector('#form-project-region').value
        modalProject = modalContactForm.querySelector('#form-project-name').value
        modalSalutation = modalContactForm.querySelector('#form-salutation').value
        modalFirstname = modalContactForm.querySelector('#form-first-name').value
        modalLastname = modalContactForm.querySelector('#form-last-name').value
        modalEmail = modalContactForm.querySelector('#form-email').value.toLowerCase()
        modalPhone = modalContactForm.querySelector('#form-phone').value
        modalPdpa = modalContactForm.querySelector('#form-pdpa').checked
    
        if(modalRegion == ""){
            alert('Please select a project region.')
            modalIsValid = false
        }
        else if(modalProject == ""){
            alert('Please select a project.')
            modalIsValid = false
        }
        else if(modalSalutation == ""){
            alert('Please select your salutation.')
            modalIsValid = false
        }
        else if (modalFirstname == ""){
            alert('Please fill up your first name.')
            modalIsValid = false
        }
        else if (modalLastname == ""){
            alert('Please fill up your last name.')
            modalIsValid = false
        }
        else if (!validateEmail(modalEmail)){
            alert('Please fill up your email.')
            modalIsValid = false
        }
        else if (modalPhone == ""){
            alert('Please fill up your contact number.')
            modalIsValid = false
        }
        else if (!modalPdpa){
            alert('Please read and agree the Terms & Conditions.')
            modalIsValid = false
        } else {
            modalIsValid = true
        }
    
    }

    function validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}

export default propertyFormSubmit;